import { FAQ } from '@/data/faq';
import { WA_LINKS } from '@/lib/whatsapp';

import { Section, SectionHeading } from '../common/Section';
import { WhatsAppIcon } from '../common/icons';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Button } from '../ui/button';

export function FaqSection() {
  return (
    <Section tone="white" size="md" container="sm">
      <SectionHeading
        eyebrow="Dúvidas frequentes"
        title="Tudo o que você precisa saber"
        description="E se ficar qualquer dúvida, é só chamar no WhatsApp."
        className="mb-10"
      />

      <Accordion type="single" collapsible className="flex flex-col gap-3">
        {FAQ.map((item, index) => (
          <AccordionItem key={item.question} value={`faq-${index}`}>
            <AccordionTrigger>{item.question}</AccordionTrigger>
            <AccordionContent>{item.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-8 flex justify-center">
        <Button asChild variant="whatsapp" size="md">
          <a href={WA_LINKS.help} target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon aria-hidden="true" />
            Ainda tenho uma dúvida
          </a>
        </Button>
      </div>
    </Section>
  );
}
